
const MissionPage = () => {
  return (
    <div className="min-h-screen" style={{
      backgroundImage: 'url(/lovable-uploads/db25a697-0862-4390-b809-10e65172b280.png)',
      backgroundSize: '100% auto',
      backgroundPosition: 'top center',
      backgroundRepeat: 'no-repeat',
      backgroundColor: '#000',
      backgroundAttachment: 'scroll'
    }}>
      <div className="bg-slate-900/80 text-white py-16 backdrop-blur-sm">
        <div className="container-custom">
          <h1 className="text-4xl md:text-5xl font-bold text-white drop-shadow-lg">Our Mission</h1>
          <p className="text-xl mt-4 text-slate-200 drop-shadow-md">
            Our vision and goals for the Ọmọ Odùduwà community
          </p>
        </div>
      </div>

      <div className="container-custom py-16">
        <div className="max-w-3xl mx-auto">
          <h2 className="section-title text-center text-white drop-shadow-lg">Vision Statement</h2>
          <div className="bg-amber-600/90 text-white p-8 rounded-lg mb-12 text-center backdrop-blur-sm border border-amber-500">
            <p className="text-xl font-medium italic drop-shadow-md">
              "To cultivate a vibrant, united, and progressive Yoruba community where cultural heritage 
              flourishes alongside social and economic advancement."
            </p>
          </div>
          
          <div className="p-8 rounded-lg backdrop-blur-sm text-white mb-12 bg-slate-800/90 border border-slate-700">
            <h2 className="section-subtitle text-white drop-shadow-lg">Mission Statement</h2>
            <p className="mb-8 text-slate-200 drop-shadow-sm">
              The Ọmọ Odùduwà is dedicated to promoting civic engagement, cultural preservation, 
              and sustainable development across Yoruba communities. We strive to empower our people through 
              education, advocacy, and community initiatives that honor our heritage while embracing innovation 
              and progress.
            </p>

            <h2 className="section-subtitle text-white drop-shadow-lg">Our Goals</h2>
            <div className="space-y-6 mb-12">
              <div className="border-l-4 border-amber-500 pl-4 bg-slate-900/50 p-4 rounded-r-lg">
                <h3 className="font-bold text-lg text-white drop-shadow-md">Promote Civic Participation</h3>
                <p className="text-slate-200 drop-shadow-sm">
                  Encourage and facilitate active participation in democratic processes and governance at 
                  all levels, fostering informed citizenship and accountability.
                </p>
              </div>
              
              <div className="border-l-4 border-amber-500 pl-4 bg-slate-900/50 p-4 rounded-r-lg">
                <h3 className="font-bold text-lg text-white drop-shadow-md">Preserve Cultural Heritage</h3>
                <p className="text-slate-200 drop-shadow-sm">
                  Document, promote, and celebrate Yoruba language, arts, traditions, and history to 
                  ensure their transmission to future generations.
                </p>
              </div>
              
              <div className="border-l-4 border-amber-500 pl-4 bg-slate-900/50 p-4 rounded-r-lg">
                <h3 className="font-bold text-lg text-white drop-shadow-md">Drive Economic Development</h3>
                <p className="text-slate-200 drop-shadow-sm">
                  Support entrepreneurship, sustainable business practices, and economic initiatives that 
                  create opportunities and prosperity within Yoruba communities.
                </p>
              </div>
              
              <div className="border-l-4 border-amber-500 pl-4 bg-slate-900/50 p-4 rounded-r-lg">
                <h3 className="font-bold text-lg text-white drop-shadow-md">Foster Education & Skills Development</h3>
                <p className="text-slate-200 drop-shadow-sm">
                  Provide educational resources, mentorship, and skills training to equip community members 
                  for success in a rapidly changing world.
                </p>
              </div>
              
              <div className="border-l-4 border-amber-500 pl-4 bg-slate-900/50 p-4 rounded-r-lg">
                <h3 className="font-bold text-lg text-white drop-shadow-md">Strengthen Community Bonds</h3>
                <p className="text-slate-200 drop-shadow-sm">
                  Build networks of support and collaboration among Yoruba people at home and in the diaspora, 
                  fostering unity and shared purpose.
                </p>
              </div>
            </div>

            <h2 className="section-subtitle text-white drop-shadow-lg">Our Approach</h2>
            <p className="mb-4 text-slate-200 drop-shadow-sm">
              We pursue our mission through a combination of grassroots initiatives, strategic partnerships, 
              and evidence-based advocacy. By engaging with community members, government officials, businesses, 
              and cultural institutions, we create collaborative solutions to shared challenges.
            </p>
            <p className="text-slate-200 drop-shadow-sm">
              The Ọmọ Odùduwà is committed to transparency, inclusivity, and accountability in 
              all our endeavors. We welcome the participation and support of all who share our vision for a 
              thriving Yoruba community that honors its past while embracing the opportunities of the future.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MissionPage;
